import { useContext, useState } from "react"
import { useFirestore, useFirestoreOrderBy } from "../../firebase/useFirestore"
import { db, timestamp } from "../../firebase/config"
import { client } from "../../hooks/Client"
import { SavedIcon } from "../../StateManagment/SavedIcon"
import useSettings from "../../hooks/Settings"
import saveFile from "../../hooks/SaveFile"
import AddItemTableRow from "../common/AddItemTableRow"
import { v4 as uuid } from 'uuid'
import deleteIcon from '../../images/icons/delete-icon.png'

const PortfolioContext = () => {
    const [saved, setSaved] = useContext(SavedIcon)
    const secundairyColor = useSettings().SecundairyColor

    const [showUpload, setShowUpload] = useState(false)
    const [file, setFile] = useState(null)
    const [fileMeta, setFileMeta] = useState(null)

    const portfolioContext = useFirestoreOrderBy("PortfolioContext", "Position", "asc")

    // After the file is uploaded a onFinalize cloud function runs to create a vector and store it in the document. 
    // The function name is embedPortfolioDocument
    const fileHandler = (e) => {
        saveFile(e, setFile, setFileMeta)
    }

    const saveDocument = () => {
        if (!file || !fileMeta) return

        db.collection('PortfolioContext')
        .add({
            ID: uuid(),
            Compagny: client,
            CompagnyID: client,
            Timestamp: timestamp,
            Title: fileMeta.name,
            URL: file,
            FilePath: fileMeta.name,
            Position: portfolioContext ? portfolioContext.length + 1 : 1,
        })
        .then(() => {
            setSaved('flex')
            setShowUpload(false)
            setFile(null)
            setFileMeta(null)
        })
    }

    const deleteDocument = (e) => {
        const docid = e.target.dataset.docid

        db.collection('PortfolioContext')
        .doc(docid)
        .delete()
    }

    return (
        <div className="settings-container">
            <div className="profile-inner-container">
                <div className="divider">
                    <h2>Context</h2>
                    <table>
                        <thead>
                            <tr>
                                <th style={{backgroundColor: secundairyColor}}>DOCUMENT</th>
                                <th style={{backgroundColor: secundairyColor}}>VERWIJDEREN</th>
                            </tr>
                        </thead>
                        <tbody>
                            {portfolioContext && portfolioContext.map(doc => (
                                <tr key={doc.ID}>
                                    <td>
                                        <a href={doc.URL} target="_blank" rel="noreferrer">{doc.Title}</a>
                                    </td>
                                    <td>
                                        <img src={deleteIcon} alt="Delete" className='table-delete-icon' data-docid={doc.docid} onClick={deleteDocument} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <AddItemTableRow toolTipContent={'Document toevoegen'} onClick={() => setShowUpload(!showUpload)} />
                    <div className='add-options-container' style={{display: showUpload ? 'flex' : 'none'}}>
                        <input type="file" accept="application/pdf" onChange={fileHandler} />
                        <div className='add-options-upload-buttons-container'>
                            <button className='button-simple' onClick={() => setShowUpload(false)}>Annuleren</button>
                            <button className='button-simple' onClick={saveDocument}>Uploaden</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PortfolioContext
